import ReactModal from 'react-modal'

import './styles.css'

interface Props {
  children: any
  isOpen: boolean
  [key: string]: any
}

const Modal = ({ children, isOpen, ...rest }: Props) => {
  const modalProps = {
    isOpen,
    overlayClassName: 'pm-modal-overlay',
    ...rest,
  }

  return (
    <ReactModal className="pm-modal" {...modalProps}>
      {children}
    </ReactModal>
  )
}

export default Modal
